import { lazy } from "react";
import { Building2 } from "lucide-react";
import type { AdminModule } from "../types";

const AccountsSearch = lazy(() =>
  import("./pages/AccountsSearch").then((m) => ({ default: m.AccountsSearch })),
);
const AccountDetail = lazy(() =>
  import("./pages/AccountDetail").then((m) => ({ default: m.AccountDetail })),
);

// Account 360 (RFC-350): a customer's business is the billing entity. The
// search page is the sidebar landing; :id is the tabbed 360 hub, also reached
// by drilling in from a user row.
export const accountsModule: AdminModule = {
  key: "accounts",
  label: "Accounts",
  description: "The business 360: team, plan, quota, payments, usage.",
  group: "customers",
  icon: Building2,
  requiredPermission: "admin.accounts.read",
  routes: [
    { path: "search", label: "Search", element: <AccountsSearch /> },
    { path: ":id", element: <AccountDetail /> },
  ],
};
